import { render } from "./ChoiseKeyt.vue?vue&type=template&id=35e48a19"
import script from "./ChoiseKeyt.vue?vue&type=script&lang=js"
export * from "./ChoiseKeyt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__